export interface CountryType {
  country: string;
}

export const countries: ReadonlyArray<CountryType> = [
  { country: 'AR' },
  { country: 'CL' },
  { country: 'CO' },
  { country: 'DK' },
  { country: 'EC' },
  { country: 'ES' },
  { country: 'EE' },
  { country: 'FI' },
  { country: 'MX' },
  { country: 'SI' },
  { country: 'US' },
  { country: 'VE' }
];

export const countriesTracking = [
  { country: 'ES', language: 'es' }, // España
  { country: 'EE', language: 'en' }, // Estonia
  { country: 'FI', language: 'fi' }, // Finlandia
  { country: 'AR', language: 'es' }, // Argentina
  { country: 'BO', language: 'es' }, // Bolivia
  { country: 'BR', language: 'pt' }, // Brasil
  { country: 'BR', language: 'en' }, // Brasil (en)
  { country: 'CL', language: 'es' }, // Chile
  { country: 'CO', language: 'es' }, // Colombia
  { country: 'CR', language: 'es' }, // Costa Rica
  { country: 'EC', language: 'es' }, // Ecuador
  { country: 'GT', language: 'es' }, // Guatemala
  { country: 'MX', language: 'es' }, // México
  { country: 'MX', language: 'en' }, // México (en)
  { country: 'NI', language: 'es' }, // Nicaragua
  { country: 'PA', language: 'es' }, // Panamá
  { country: 'PE', language: 'es' }, // Perú
  { country: 'PY', language: 'es' }, // Paraguay
  { country: 'SV', language: 'es' }, // El Salvador
  { country: 'UY', language: 'es' }, // Uruguay
  { country: 'VE', language: 'es' }, // Venezuela
  { country: 'US', language: 'en' }, // Estados Unidos (inglés)
  { country: 'US', language: 'es' }, // Estados Unidos (español)
  { country: 'US', language: 'zh' }, // Estados Unidos (chino)
  { country: 'US', language: 'fr' }, // Estados Unidos (francés)
  { country: 'US', language: 'de' }, // Estados Unidos (alemán)
  { country: 'CA', language: 'en' }, // Canadá (inglés)
  { country: 'CA', language: 'fr' }, // Canadá (francés)
  { country: 'CA', language: 'es' }, // Canadá (español)
  { country: 'CA', language: 'zh' }  // Canadá (chino)
];

export default countries;
